<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const CONJOINED_CELL_SETTINGS = { preserveCase: true };

const conjoinedValue = computed(() => props.rowData?.[props.settings?.render?.conjoinedKey]);
</script>

<template>
  <div class="flex min-w-0 flex-col gap-0.5">
    <ALinkCell
      v-if="settings?.render?.href"
      :field
      :rowData
      :settings
    />

    <ADefaultCell
      v-else
      :field
      :rowData
      :settings
    />

    <ADefaultCell
      v-if="conjoinedValue"
      class="text-xs text-gray-500"
      :field="conjoinedValue"
      :rowData
      :settings="CONJOINED_CELL_SETTINGS"
    />
  </div>
</template>
